export default function UniquenessIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.999 6.99902L16.999 12.999"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.00098 15.9994L15.7009 4.29953C15.8878 4.1163 16.1391 4.01367 16.4009 4.01367C16.6626 4.01367 16.914 4.1163 17.1009 4.29953L19.7009 6.89951C19.8841 7.08644 19.9867 7.33775 19.9867 7.5995C19.9867 7.86126 19.8841 8.11257 19.7009 8.2995L8.00095 19.9994H4.00098V15.9994Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
